<template>
  <kst-section items-mode>
    <kst-table input-mode :data="deliveryData.Items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchID"
        :label="DlvItemCatalog.DispatchID.ColumnLabel"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="DlvItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.getItemInfo(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="DlvItemCatalog.Packaging.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="DlvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="Quantity"
        :label="DlvItemCatalog.Quantity.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="DlvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-weight-full"
        field="Weight"
        :label="DlvItemCatalog.Weight.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="DlvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-weight-total"
        field="TotalWeight"
        :label="DlvItemCatalog.TotalWeight.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="DlvItemCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import DlvItemCatalog from "../DlvItemCatalog.js";
import Model from "../DlvModel.js";

export default {
  props: {
    deliveryData: Object
  },
  data: () => ({
    DlvItemCatalog: DlvItemCatalog,
    Model: Model
  })
}
</script>